export default function findObj(array, obj, key) {
  for (let i = 0, len = array.length; i < len; i += 1) {
    if (array[i][key] === obj) {
      return i;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/findObj.js